export const clientId = '385681930280-t542cbp385soh20gtfluaia2kjca9dtt.apps.googleusercontent.com';
